import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const getAuthHeader = () => {
  const token = localStorage.getItem('notaToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

const catlogService = {
  // Study Abroad Payment Endpoints
  createStudyPaymentRequest: async () => {
    const response = await axios.post(
      `${API_URL}/api/catlog/study-abroad/payment-request`,
      {},
      getAuthHeader()
    );
    return response.data;
  },

  automateStudyPayment: async (requestId) => {
    const response = await axios.post(
      `${API_URL}/api/catlog/study-abroad/automate`,
      { requestId },
      getAuthHeader()
    );
    return response.data;
  },

  getStudyPaymentStatus: async (requestId) => {
    const response = await axios.get(
      `${API_URL}/api/catlog/study-abroad/status/${requestId}`,
      getAuthHeader()
    );
    return response.data;
  },

  // Work Abroad Payment Endpoints
  createWorkPaymentRequest: async () => {
    const response = await axios.post(
      `${API_URL}/api/catlog/work-abroad/payment-request`,
      {},
      getAuthHeader()
    );
    return response.data;
  },

  automateWorkPayment: async (requestId) => {
    const response = await axios.post(
      `${API_URL}/api/catlog/work-abroad/automate`,
      { requestId },
      getAuthHeader()
    );
    return response.data;
  },

  getWorkPaymentStatus: async (requestId) => {
    const response = await axios.get(
      `${API_URL}/api/catlog/work-abroad/status/${requestId}`,
      getAuthHeader()
    );
    return response.data;
  }
};

export default catlogService;
